import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid2, Typography } from '@mui/material';
import { VTKDataRefreshOneDriveAction } from '../actions/DataManagementActions';
import { enqueueSnackbar } from 'actions';
import ConfirmDialog from './ConfirmDialog';

// locked: true while another VTK import is running (shared semaphore) - disables submission.
// onAfterSubmit: optional callback invoked once the request settles, so a parent hub can refresh the lock status.
const VTKDataRefreshOneDriveForm = ({ locked = false, onAfterSubmit } = {}) => {
	const userId = useSelector(state => state.session.user.id);
	const dispatch = useDispatch();

	const [confirmOpen, setConfirmOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const handleConfirm = async () => {
		const formData = new FormData();
		formData.append('UserId', userId);

		try {
			setIsLoading(true);
			const data = await VTKDataRefreshOneDriveAction(formData);
			dispatch(enqueueSnackbar({ message: data.message, options: { variant: 'success' } }));
		} catch (error) {
			dispatch(enqueueSnackbar({ message: `The process has not started because an error occured. ${error}`, options: { variant: 'error' } }));
		} finally {
			setIsLoading(false);
			setConfirmOpen(false);
			if (onAfterSubmit) onAfterSubmit();
		}
	};

	return (
		<Grid2 container spacing={2}>
			{locked && (
				<Grid2 item size={12}>
					<Typography variant="body2" align="center" color="error">
						An import is currently running. Please wait for it to finish before starting a new one.
					</Typography>
				</Grid2>
			)}

			<Grid2 item size={12}>
				<Button
					variant="contained"
					color="primary"
					fullWidth
					onClick={() => setConfirmOpen(true)}
					disabled={isLoading || locked}
				>
					Update Data
				</Button>
			</Grid2>

			<ConfirmDialog
				open={confirmOpen}
				title="Update Data"
				message="Are you sure you want to update all data?"
				onConfirm={handleConfirm}
				onCancel={() => setConfirmOpen(false)}
				isLoading={isLoading}
			/>
		</Grid2>
	);
};

export default VTKDataRefreshOneDriveForm;
